import React, { createContext, useContext, useState } from 'react';

export type AppLang = 'en' | 'hi';

interface LanguageContextValue {
  lang: AppLang;
  setLang: (l: AppLang) => void;
  t: (en: string, hi: string) => string;
}

const LanguageContext = createContext<LanguageContextValue>({
  lang: 'en',
  setLang: () => {},
  t: (en) => en,
});

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLangState] = useState<AppLang>(() => {
    try { return (localStorage.getItem('app-lang') as AppLang) || 'en'; } catch { return 'en'; }
  });

  const setLang = (l: AppLang) => {
    setLangState(l);
    try { localStorage.setItem('app-lang', l); } catch {}
  };

  const t = (en: string, hi: string) => lang === 'hi' ? hi : en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
